<template>
  <div id="used-musical-instruments"></div>
  <section id="portfolio" class="bg-light">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="text-uppercase section-heading">μεταχειρισμενα πνευστα μουσικα οργανα</h2>
          <div class="section-subheading text-muted">
            Μεγάλη συλλογή από παραδοσιακά κλαρίνα δημοτικής μουσικής, σιμπεμόλ και λα σε γερμανικό σύστημα (Muller
            system).
            <br/>
            Μεγάλη συλλογή από κλαρινέτα κλασικής μουσικής, γαλλικό σύστημα (Bοehm system).
            <br/>
            Παλιά πνευστά μουσικά όργανα, αντίκες για διακόσμηση και συλλέκτες.
            <br/>
            Χειροποίητες σάλπιγγες παρέλασης ελληνικής κατασκευής.
            <br/>
            Όλα τα μεταχειρισμένα όργανα είναι σε πολύ καλή κατάσταση, έχουν επισκευαστεί και συντηρηθεί και διαθέτουν
            εγγύηση καλής λειτουργίας ενός χρόνου.
          </div>
          <br/>
        </div>
      </div>
      <div class="row">
        <div v-for="instrument in used_musical_instruments" v-bind:key="instrument.id"
             class="col-sm-6 col-md-4 portfolio-item">
          <img class="img-fluid" :src="fixPath(instrument.image)" :alt="instrument.description"/>
          <div class="portfolio-caption">
            <h4>{{ instrument.title }}</h4>
            <p class="text-muted"><strong>{{ instrument.description }}</strong></p>
            <p class="text-muted"><strong>{{ instrument.price }}</strong></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import usedInstruments from '@/data/used_musical_instruments.json'

export default {
  name: "AppUsed",
  data() {
    return {
      used_musical_instruments: usedInstruments.items
    }
  },
  methods: {
    fixPath(path) {
      if (!path || path.startsWith('/')) return path;
      const withProtocol = path.startsWith('http') ? path : 'https://' + path;
      try {
        return new URL(withProtocol).pathname.replace(/^\/public\//, '/');
      } catch {
        return path;
      }
    }
  }
};
</script>

<style scoped>
.portfolio-item img {
  width: 100%;
  height: 260px;
  object-fit: cover;
}
</style>
